import { Suspense, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import ResumenFiltrosComponent from '../components/resumenFiltrosComponent';
import { useValidadorAsientosContablesContext } from '../../../../context/validadorAsientosContablesContext';
import { useNavigate } from 'react-router-dom';
import ResumenEnviadosComponent from '../components/resumenEnviadosComponent';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';



function ResumenEnviados() {
    
    const navigate = useNavigate();
    const { formFilters } = useValidadorAsientosContablesContext();
    
    const breadcrumbItems = [
        { label: 'Contabilidad', url: '/contabilidad' },
        { label: 'Validador de Asientos', url: '/contabilidad/validadorAsientos', state: formFilters },
        { label: 'Analizar movimientos contables', url: '/contabilidad/validadorAsientos/analizarMovimientosContables', state: formFilters },
        { label: 'Enviados', active: true, state: formFilters },
    ];

    useEffect(() => {
        if( !formFilters ) navigate('/contabilidad/validadorAsientos');
    }, [ formFilters, navigate]);
    
    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems } />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            { formFilters && (
                                <>
                                    <ResumenFiltrosComponent />
                                    <ResumenEnviadosComponent />
                                </>
                            ) }
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    )
}

export default ResumenEnviados;